export default "__VITE_ASSET__CzEXdamH__"